import React from 'react';
import { Modal } from '@/components/common/Modal';
import { Button } from '@/components/common/Button';

interface EstimatedTimeModalProps {
  isOpen: boolean;
  onClose: () => void;
  taskId?: number|string;
}

interface TimeEntry {
  initials: string;
  fullName: string;
  tasks: number;
  minutes: number;
  formattedTime: string;
}

export const EstimatedTimeModal: React.FC<EstimatedTimeModalProps> = ({ isOpen, onClose }) => {
  const timeEntries: TimeEntry[] = [
    { initials: 'AG', fullName: 'Arpit Gupta', tasks: 2, minutes: 120, formattedTime: '120 mins (2h)' },
    { initials: 'AP', fullName: 'Akash Patel', tasks: 3, minutes: 90, formattedTime: '90 mins (1h 30m)' },
    { initials: 'JS', fullName: 'Jay Soni', tasks: 4, minutes: 135, formattedTime: '135 mins (2h 15m)' },
    { initials: 'MB', fullName: 'Mohammed Bilal', tasks: 1, minutes: 60, formattedTime: '60 mins (1h)' },
    { initials: 'SV', fullName: 'Sahil Vhora', tasks: 2, minutes: 85, formattedTime: '85 mins (1h 25m)' },
    { initials: 'VP', fullName: 'Vatsal Patel', tasks: 9, minutes: 245, formattedTime: '245 mins (4h 5m)' },
  ];

  const totalMinutes = timeEntries.reduce((sum, entry) => sum + entry.minutes, 0);
  const totalHours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  const totalFormattedTime = `${totalMinutes} mins (${totalHours}h ${remainingMinutes}m)`;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Estimated Time per User" size="md" className='py-0'>
      <div className="">
        {/* Table */}
        <div className="overflow-hidden border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 border-t-0">
              <tr>
                <th className="px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  USER
                </th>
                <th className="px-4 py-2 border-l border-r text-xs font-medium text-gray-500 uppercase tracking-wider">
                  TASKS
                </th>
                <th className="px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                  ESTIMATED TIME
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {timeEntries.map((entry, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-0 py-3 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="ml-4 flex items-center space-x-2">
                        <div className="text-sm font-medium text-white rounded-full p-1 bg-gray-500">{entry.initials}</div>
                        <div className="text-sm text-gray-500">{entry.fullName}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap border-r border-l">
                    <span className="text-sm text-gray-900 font-medium">
                      {entry.tasks}
                    </span>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span className="text-sm text-gray-900">
                      {entry.formattedTime}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Total Time */}
        <div className="mt-0 px-4 py-3 rounded-lg">
          <div className="flex items-center justify-between">
            <span className="text-sm font-semibold text-gray-900">
              Total Estimated Time: {totalFormattedTime}
            </span>
            <Button 
              variant="secondary" 
              onClick={onClose}
              className="font-semibold"
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};